import { render, staticRenderFns } from "./productCreateDialog.vue?vue&type=template&id=28883e71&scoped=true"
import script from "./productCreateDialog.vue?vue&type=script&lang=js"
export * from "./productCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./productCreateDialog.vue?vue&type=style&index=0&id=28883e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28883e71",
  null
  
)

export default component.exports